import url from "url"
import omit from "lodash/omit"
import qs from "query-string"

export default function getCurrentUrl() {
  const { host, protocol, pathname, query } = url.parse(document.location.href)

  /* Before send current url, ensure it has no unsatisfactory param */
  const queryObject = omit(qs.parse(query), [`code`, `requestToken`])

  const result = url.format({
    host,
    protocol,
    pathname,
    query: queryObject,
  })

  return result
}
